import lessonsParser from './lessonsParser';
import { LessonsType, LessonsDataType } from './types';

const mapLessons = (data: LessonsType): LessonsDataType =>
  data.map(lessonsParser);

export default mapLessons;



// WEBPACK FOOTER //
// ./src/services/api/remoteedu/utils/mapLessons.ts